import { render } from "./BasicPersonalData.vue?vue&type=template&id=4134806a&scoped=true&ts=true"
import script from "./BasicPersonalData.vue?vue&type=script&lang=ts"
export * from "./BasicPersonalData.vue?vue&type=script&lang=ts"

import "./BasicPersonalData.vue?vue&type=style&index=0&id=4134806a&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4134806a"]])

export default __exports__